import { axiosAuthInstance } from "../utils/getSubdomain"
import { ILoginProps } from "./type"

export const login = (data: ILoginProps) => {
  return axiosAuthInstance.post("/login/", data)
}
export const requestPasswordReset = (email: string) => {
  return axiosAuthInstance.post("/request-reset/", { email })
}

export const verifyOtp = (email: string, otp: string) => {
  return axiosAuthInstance.post("/verify-otp/", { email, otp })
}

export const resetPassword = (
  email: string,
  gtoken: string,
  new_password: string
) => {
  return axiosAuthInstance.post("/reset-password/", {
    email,
    gtoken,
    new_password,
  })
}
